module.exports = __webpack_public_path__ + "img/science-and-the-production-of-ignorance--when-the-quest-for-knowledge-is-thwarted-cover.0e3e58c8.jpg";